document.addEventListener("DOMContentLoaded", () => {
  const menuItems = document.querySelectorAll("header-menu details");

  menuItems.forEach((menu) => {
    const summary = menu.querySelector("summary");
    const megaMenu = menu.querySelector(".mega-menu");
    const megaMenuOverlay = menu.querySelector(".mega-menu-overlay");
    let timeout;
    
    summary.addEventListener("mouseenter", function () {
      clearTimeout(timeout);
      menu.setAttribute("open", true);
    });

    megaMenu.addEventListener("mouseenter", function () {
      clearTimeout(timeout);
    });

    menu.addEventListener("mouseleave", function () {
      timeout = setTimeout(() => {
        menu.removeAttribute("open");
      }, 200);
    });

    if (megaMenuOverlay) {
      megaMenuOverlay.addEventListener("mouseenter", function () {
        menu.removeAttribute("open");
      });
    }
  });

  const collapsibleButton = document.getElementsByClassName("mobile-nav__link");
  let i;
  for (i = 0; i < collapsibleButton.length; i++) {
    collapsibleButton[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      var isExpanded = this.classList.contains("active");
      this.setAttribute("aria-expanded", isExpanded);
      if (content.style.height) {
        content.style.height = null;
      } else {
        content.style.height = "auto";
      }
    });
  }
});
